<template>
    <div>
        <v-row>
            <v-col><v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon></v-col>
            


        </v-row>
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <div class="card-title">
                    {{ $t('ChangeColor')}}
                </div>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="4" v-for="(item, index) in value"
                               :key="index">
                            <v-color-picker v-model="item.color"
                                            mode="hexa"></v-color-picker>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Horizontal layout -->
        

        <!-- Vertical layout -->
        <v-row>
            <v-col>
                <v-row class="d-flex align-center justify-space-between " style="background-color: #efeded; border-radius: 8px;">
                    <v-col cols="auto" style="position:relative">

                        <div :style="'position:absolute;right:10px;top:190px;width:100px;height:201px;background-image:url(/satisfactionbackground.png);background-size:contain;background-repeat:no-repeat;background-position:top center'">
                            <table style="width:100%">
                                <tr>
                                    <td style="text-align:center;font-size:12px;color:white;padding-top:20px"><img src="/satisfactionstars.png" style="margin:auto" /><br />{{$t('OverAllSAtisfaction')}}</td>
                                </tr>
                                <tr><td style="font-weight: 700; padding-top: 40px; text-align: center; font-size: 25px; color: #5EBFCE">{{publicsatisfactoryPerc}}%</td></tr>
                            </table>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <!-- Satisfaction Table -->
                    <v-col cols="2">
                    </v-col>
                    <!-- Satisfaction Levels with Vertical Bars -->
                    <v-col cols="10" class="d-flex justify-center">
                        <v-row>
                            <v-col v-for="(item, index) in value"
                                   :key="index"
                                   class="text-center d-flex flex-column align-center" cols="4" md="4" @click="filterQuestionOption(item)">
                                <img :src="`face${item.id}.png`" style="width:50px" /><br />
                                <div style="font-size: 21px; color: #000;">{{ item.percentage }}%</div>
                                <div class="bar-container chart4 d-flex flex-column justify-end">
                                    <div class="bar"
                                         :style="{
                                      height: `${item.percentage}%`,
                                      backgroundColor: item.color
                                    }">
                                        <!--<table style="height: 100%; margin-top: -10px; width: 100%; font-weight: bold; font-size: 21px;"><tr><td valign="middle"><span>{{ item.percentage }}%</span></td></tr></table>-->
                                    </div>
                                </div>
                                <div class="mt-2" style="font-size: 21px; color: #000;">{{ item.level }}</div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { Chart, ArcElement, Tooltip, Legend, Plugin, PointElement } from 'chart.js'


    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },

        },
        data() {
            return {
                instance: null,
                selectedChart: 'chart1', // Default to horizontal view
                legend: [
                    { text: 'راضي', color: '#64DD17' },
                    { text: 'محايد', color: '#FFEB3B' },
                    { text: 'غير راضي', color: '#FF6D00' },
                ],
                // Chart data
                bubbleData: [
                    { x: 1, y: 1, r: 63, color: '#64DD17' }, // Satisfied
                    { x: 2, y: 2, r: 29, color: '#FFEB3B' }, // Neutral
                    { x: 3, y: 3, r: 20, color: '#FF6D00' }, // Unsatisfied
                ],
                dialog: false
            }
        },
        mounted() {
            Chart.register(ArcElement, Tooltip, Legend, PointElement)

            this.renderChartOne()
        },
        watch: {
            selectedChart: {
                handler: function (val, oldVal) {
                    if (this.selectedChart == 'chart1') {

                        this.renderChartOne()
                    }


                },
                deep: true
            },
            value: {
                handler: function (val, oldVal) {
                    if (this.selectedChart == 'chart1') {

                        this.renderChartOne()
                    }


                },
                deep: true
            }
        },
        computed: {
            publicsatisfactoryPerc() {

                var five = this.value.filter(x => x.id == 5)

                var satisfactory = 0
                if (five.length > 0)
                    satisfactory += five[0].percentage

                return satisfactory
            },
            publicsatisfactoryTotal() {
                var satisfactory = 0
                for (var i = 0; i < this.value.length; i++) {
                    satisfactory += this.value[i].count
                }
                return satisfactory
            }

        },

        methods: {
            getCircleStyle(circle) {
                const minSize = 50 // Minimum size for small percentages
                const maxSize = 150 // Maximum size for large percentages
                const size = Math.max((circle.percentage / 100) * maxSize, minSize)
                return {
                    backgroundColor: circle.color,
                    width: `${size}px`,
                    height: `${size}px`,
                    fontSize: `${size / 5}px`,
                }
            },
            renderChartOne() {


                var colors = []
                var data = []
                for (var i = 0; i < this.value.length; i++) {
                    colors.push(this.value[i].color)
                    data.push(this.value[i].count)
                }
                if (document.getElementById('chartthree-1')) {
                    const ctx = document.getElementById('chartthree-1').getContext('2d')


                    if (this.instance) {
                        this.instance.destroy()
                    }

                    this.instance = new Chart(ctx, {
                        type: 'doughnut',
                        data: {
                            labels: this.value.map((label) => label.level),
                            datasets: [
                                {
                                    data: data,

                                    backgroundColor: colors
                                },
                            ],
                        },
                        options: {
                            cutout: '80%',
                            plugins: {
                                tooltip: { enabled: true },
                                legend: { display: false },

                            },
                        },
                    })
                }

            }
        },
    }
</script>

<style scoped>
    .text-center {
        text-align: center;
    }

    .text-right {
        text-align: right;
    }

    .text-caption {
        font-weight: bold;
        background-color: #eef0f2;
        padding: 5px;
        border-radius: 5px;
    }

    .bar-container {
        height: 150px;
        width: 30px;
        background-color: #eef0f2;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-radius: 4px;
    }

    .bar {
        width: 100%;
        border-radius: 4px;
    }

    .chart3 {
        width: 50px;
        height: 300px;
        position: relative
    }

    .chart4 {
        width: 80px;
        max-width:100%;
        height: 200px;
        position: relative;
        border-radius: 20px;
        border: 5px solid white;
    }

        .chart4 .bar {
            border-radius: 10px;
        }

    .d-flex {
        display: flex;
    }

    .align-center {
        align-items: center;
    }

    .flex-column {
        flex-direction: column;
    }

    .rotated-text {
        display: inline-block; /* Ensures the rotation works properly */
        transform: rotate(270deg); /* Rotates text by 45 degrees */
        transform-origin: center; /* Sets the point around which the text is rotated */
        position: absolute;
        bottom: 100px;
        width: 280px;
        font-weight: 700
    }

    .backone {
        background-color: white;
        border-radius: 25px;
        height: 150px;
        width: 150px;
        border: 1px solid #33A1AA;
    }

        .backone .title {
            background-image: url(/public/triplesatchartonetitle.png);
            background-size: 100%;
            background-repeat: no-repeat;
            height: 60px;
            line-height: 50px;
            color: white;
            text-align: center;
            font-size: 14px !important;
        }

        .backone .text {
            color: #33A1AA;
            text-align: center;
            font-size: 26px;
            padding-top: 20px;
        }

    .circle-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;
        gap: 10px;
    }

    .circle {
        border-radius: 50%;
        color: white;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
    }
</style>
